import * as Joi from 'joi';
import { InstructionNonNationalFormData } from '../../../models';

const instructionNonNationalSchema = Joi.object<InstructionNonNationalFormData>({
  levelSeekingAdmission: Joi.object().required().messages({
    'any.required': `Please select You are Now Seeking Admission to`,
    'object.base': `Please select You are Now Seeking Admission to`,
  }),
});

export default instructionNonNationalSchema;
